import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Zigzag, ZigzagStrip } from '../../Themes/Brand';

interface StatusCardProps {
    accentColor: string;
    /** Big status code (404, 401). Mutually exclusive with icon. */
    code?: string;
    icon?: IconDefinition;
    title: string;
    text: string;
    action?: React.ReactNode;
    minHeight?: string;
}

/** Shared full-screen status/error card: silk canvas, one card, the mark. */
const StatusCard: React.FC<StatusCardProps> = ({ accentColor, code, icon, title, text, action, minHeight = '100vh' }) => (
    <div style={{
        minHeight,
        backgroundColor: 'var(--st-canvas)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
    }}>
        <div style={{
            backgroundColor: 'var(--st-paper)',
            borderRadius: '16px',
            boxShadow: 'var(--st-shadow-card)',
            overflow: 'hidden',
            maxWidth: '22rem',
            width: '100%',
            textAlign: 'center',
        }}>
            <ZigzagStrip color={accentColor} />

            <div style={{ padding: '2.4rem 2rem 2rem' }}>
                {code ? (
                    <div style={{
                        fontFamily: 'var(--st-font-display)',
                        fontSize: '4.4rem',
                        fontWeight: 700,
                        color: 'var(--st-line-strong)',
                        lineHeight: 1,
                        letterSpacing: '-0.02em',
                        marginBottom: '0.4rem',
                    }}>
                        {code}
                    </div>
                ) : icon ? (
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '3.2rem',
                        height: '3.2rem',
                        borderRadius: '13px',
                        backgroundColor: accentColor + '1A',
                        marginBottom: '0.7rem',
                    }}>
                        <FontAwesomeIcon icon={icon} style={{ color: accentColor, fontSize: '1.25rem' }} />
                    </div>
                ) : null}

                <div style={{ marginBottom: '1.3rem' }}>
                    <Zigzag color={accentColor} width={44} height={9} />
                </div>

                <h2 style={{
                    fontFamily: 'var(--st-font-display)',
                    fontSize: '1.15rem',
                    fontWeight: 700,
                    color: 'var(--st-text)',
                    margin: '0 0 0.6rem',
                }}>
                    {title}
                </h2>
                <p style={{ fontSize: '0.875rem', color: 'var(--st-text-soft)', margin: action ? '0 0 2rem' : 0, lineHeight: 1.6 }}>
                    {text}
                </p>

                {action}
            </div>
        </div>
    </div>
);

export default StatusCard;
